// extracted by mini-css-extract-plugin
module.exports = {"main":"Select_main__2JZ-k","select":"Select_select__j3QIX","dropdownIndicator":"Select_dropdownIndicator__39axF","spinnerContainer":"Select_spinnerContainer__2wjCX"};